<template>
  <div class="button-group">
    <ManagePlanButton v-if="!canEditDigests" color="secondary" />
    <ButtonWithPaywall
      color="primary"
      @click="openCreateDialog"
      :fallback-action="openFreemiumModal"
    >
      <template #iconLeft>
        <i class="fa-solid fa-plus" />
      </template>
      Ajouter un récapitulatif
    </ButtonWithPaywall>
  </div>
  <div class="englobe-params">
    <div class="infos">
      <i class="fa-regular fa-circle-info"></i>
      <p class="title-medium-regular">
        Les récapitulatifs sont des résumés quotidiens ou hebdomadaires
        reprenant l'ensemble des nouveaux éléments sur la période écoulée.<br />
        Choisissez votre canal de préférence ou mettez en pause vos alertes sur
        votre page
        <RouterLink v-focus to="/user-settings/notifications"
          >Préférences de notifications</RouterLink
        >.
      </p>
    </div>
  </div>
  <PopupDialog ref="createModal" title="Ajouter un récapitulatif">
    <template #body>
      <AddEditDigestForm v-if="showForm" ref="createForm" />
    </template>
    <template #footer>
      <button v-if="showForm" v-focus class="btn-primary" @click="createDigest">
        Ajouter
      </button>
    </template>
  </PopupDialog>
</template>

<script setup type="ts">
import { computed, inject, ref } from "vue";
import AddEditDigestForm from "../molecules/AddEditDigestForm.vue";
import PopupDialog from "@follaw-fr/components/reusable/atoms/PopupDialog.vue";

import ManagePlanButton from "@follaw-fr/components/user-settings/atoms/ManagePlanButton.vue";
import ButtonWithPaywall from "@follaw-fr/components/reusable/molecules/ButtonWithPaywall.vue";
import { openDigestPaywallModalKey } from "@follaw-fr/constants/injection-keys";
import { PermissionLevel } from "@follaw-fr/constants/enums/permission-level.enum";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";

const { hasPermission } = useUserSettingsStore();
const canEditDigests = computed(() => hasPermission(PermissionLevel.BASIC));

const createModal = ref();
const showForm = ref(false);

const openCreateDialog = () => {
  showForm.value = true;
  createModal.value?.open();
};
const openFreemiumModal = inject(openDigestPaywallModalKey);


const createForm = ref();
const createDigest = () => {
  if (createForm.value?.validate()) {
    createForm.value?.form.requestSubmit();
    showForm.value = false;
  }
};
</script>

<style lang="scss" scoped>
.infos {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.938em;
  font-weight: 600;

  p {
    margin: 0;
  }

  i {
    font-size: 1.35em;
  }
}
.button-group {
  display: flex;
  flex-direction: row;
  justify-content: right;
  gap: 10px;
  margin-bottom: 20px;
}
</style>
